import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../../components/Button';
import Input from '../../components/Form/Input';
import useForm from '../../hooks/useForm';
import { api } from '../../services/api';
import { UserContext } from '../../UserContext';
import Logo from '../../assets/svg/logo.svg';
import {
    Form,
    Title,
    Submit,   
    Container,
    Logotipo,
    Center
} from './styled';
import {default as MaterialUiAlert} from '@material-ui/lab/Alert';
import { AlertTitle } from '@material-ui/lab';
import Alert from '../../components/Alert';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ResetPassword: React.FC = () => {
    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState('');

    let query = useQuery();
    if(!query.get("token") || !query.get("email")){
        window.location.href = `${process.env.REACT_APP_PUBLIC_URL}`;
    }

    const password = useForm('password');
    const password_confirmation = useForm('password');

    const {loading} = React.useContext(UserContext);

    async function doSubmit(e: React.FormEvent) {
        e.preventDefault();

        if ((password.validate() && password_confirmation.validate())) {
            if(password.value !== password_confirmation.value){
                setError("As senhas são diferentes.");
            }else{
                try{
                    const {data} = await api.post("password/reset",{
                        token: query.get("token"),
                        email: query.get("email"),
                        password: password.value,
                        password_confirmation: password_confirmation.value
                    });

                    setSuccess(data.message);
                }catch(error){
                    const result = (error as Error).message;
                    setError(result);
                }
            }
        }
    }

    const handleMessageError = () => {
        setError('');
    }

    const handleMessageSuccess = () => {
        setSuccess('');
    }

    return(
        <Container>
            {!success ?
                <Form onSubmit={doSubmit}>   
                    <Center>
                        <Logotipo title="Logo da Sultan Veste a Casa" alt="Logo da Sultan Veste a Casa"
                                  src={Logo}/>
                    </Center>                             
                    <Title>Resetar Senha</Title>
                    <Input label="Nova Senha:" autoComplete="off" id="password" type="password" {...password}/>
                    <Input label="Repita a nova senha:" id="password_confirmation" type="password" {...password_confirmation}/>

                    <Submit>
                        <div></div>
                        {loading ? <Button type="submit" disabled>Carregando...</Button> 
                                 : <Button type="submit">Enviar</Button>}
                    </Submit>                    
                    <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error}/>                    
                    <Alert open={success !== ''} onClose={handleMessageSuccess} severity="success" message={success}/>                    
                </Form>    
            :
                <MaterialUiAlert severity="success">
                    <AlertTitle>Senha alterada!</AlertTitle>
                    <Link to={`${process.env.PUBLIC_URL}/login`} title="Página de Login">Clique aqui </Link>para ir para a página de login.
                </MaterialUiAlert>
            }            
        </Container>
    );
}

export default ResetPassword;